import { CommonModule } from '@angular/common';
import { Component, Input, OnInit, forwardRef } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule, ModalController, NavController, NavParams } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { SafeHtmlPipe } from 'src/app/pipes/safe-html/safe-html';
import { UserProvider } from 'src/app/services/user/user';


@Component({
  selector: 'app-privacidade',
  templateUrl: './privacidade.page.html',
  styleUrls: ['./privacidade.page.scss'], 
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    SafeHtmlPipe,
    TranslateModule
  ],
})
export class PrivacidadePage implements OnInit {
  @Input() isModal: boolean = false;
  @Input() idInstituicao!: any;
  privacidade: string = '';

  constructor(
    public navCtrl: NavController, 
    public navParams: NavParams,
    public modalCtrl: ModalController,
    public userProvider: UserProvider
  ) {
    this.idInstituicao = this.navParams.get('idInstituicao') ? this.navParams.get('idInstituicao') : this.userProvider.idInstituicao;

    this.userProvider.getDados().then(result => {
      this.idInstituicao = this.idInstituicao ? this.idInstituicao : result?.instituicao.id;

      this.userProvider.getPrivacidade(this.idInstituicao).subscribe((data) => {
        this.privacidade = data;
        this.isModal = this.navParams.get('isModal');
      });
    });
  }

  ngOnInit() {
  }

  public closeModal() {
    this.modalCtrl.dismiss();
  }

}
